export enum UserBalanceType {
    Regular = 1,
    White = 2,
}

export const enumLabel = (value?: UserBalanceType) => {
    switch (value) {
        case UserBalanceType.Regular:
            return 'Обычный';
        case UserBalanceType.White:
            return 'White';
        default:
            return '';
    }
};
